export default "__VITE_ASSET__imRRGZtD__"